import { DOCUMENT } from 'entities/user/module'

import {
  AVAILABLE_CYRILLIC_INPUT,
  ListCitizenshipAllowLatinByAge,
} from 'shared/constants'
import {
  REGEX_EMAIL_NUMBER,
  REGEX_EMAIL_NUMBER_RU,
  REGEX_LATIN,
} from 'shared/constants/regex'

interface Props {
  passport: string
  age: string
  citizenship: string
}

export const getRegexByAgeAndCitizenship = ({
  age,
  passport,
  citizenship,
}: Props): RegExp => {
  const settingsForLatin = ListCitizenshipAllowLatinByAge?.find(
    (setting) => setting.password === passport,
  )

  const resultByAge = settingsForLatin?.ages?.includes(age) || false

  const resultCitizenship =
    citizenship?.toLocaleLowerCase() === settingsForLatin?.citizenship

  const isRussianBirthCertificate =
    AVAILABLE_CYRILLIC_INPUT.includes(citizenship?.toLocaleLowerCase()) &&
    passport === DOCUMENT.BIRTH_CERTIFICATE

  if (isRussianBirthCertificate) {
    return REGEX_EMAIL_NUMBER_RU
  }

  return resultByAge && resultCitizenship ? REGEX_LATIN : REGEX_EMAIL_NUMBER
}
